import Marquee from 'vanilla-marquee';

export default function initMarquee() {
    new Marquee(document.getElementById('marquee'), {

        speed: 20,          
        delayBeforeStart: 0, 
        duplicated: true,    
        gap: 30,             
        startVisible: true,

    });
    
}